const degreeToRadians = (degree: number): number => {
    return degree * Math.PI / 180;
};

const radiansToDegrees = (radian: number): number => {
    return radian * 180 / Math.PI;
};

const zylinderVolumenP = (kolbenFlaecheEinzeln: number, kreisringFlaecheEinzeln: number, anzahlKolben: number, verstellbereich: number, hub: number): number => {
    return ((kolbenFlaecheEinzeln * (hub + verstellbereich / 2) / 1000000) + ((anzahlKolben - 1) * kreisringFlaecheEinzeln * (hub + verstellbereich / 2) / 1000000));
};

const mathFormulaService = {
    degreeToRadians,
    radiansToDegrees,
    zylinderVolumenP
};

export default mathFormulaService;
